import { useAppDispatch } from 'src/hooks';
import { TextField } from '@mui/material';
import { useState } from 'react';
import { handleSearchInputValueChange } from './store/scenario-manager-top-bar-slice';

export default function ScenarioManagerSearchTopBar() {
  const appDispatch = useAppDispatch();
  const [scenarioSearchValue, setScenarioSearchValue] = useState('');

  const handleSearchEventValue = (searchVal: string) => {
    setScenarioSearchValue(searchVal);
    appDispatch(handleSearchInputValueChange({ inputVal: searchVal }));
  };

  return (
    <TextField
      fullWidth
      InputProps={{ sx: { fontSize: '0.65rem' } }}
      name='search-scenario'
      id='search-scenario'
      placeholder='Search Scenario, Retailer , Category...'
      size='small'
      value={scenarioSearchValue}
      onChange={(e) => handleSearchEventValue(e.target.value)}
    />
  );
}
